import { render, staticRenderFns } from "./CredentialForm.vue?vue&type=template&id=08f34a74&scoped=true&"
import script from "./CredentialForm.vue?vue&type=script&lang=js&"
export * from "./CredentialForm.vue?vue&type=script&lang=js&"
import style0 from "./CredentialForm.vue?vue&type=style&index=0&id=08f34a74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f34a74",
  null
  
)

export default component.exports